exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-text[data-v-501ec235]{font-size:16px}", "", {"version":3,"sources":["F:/myugfront/src/components/distance-finals/risk-group-modal.vue"],"names":[],"mappings":"AACA,6BACE,cAAgB,CACjB","file":"risk-group-modal.vue","sourcesContent":["\n.modal-text[data-v-501ec235] {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-501ec235","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/distance-finals/risk-group-modal.vue
// module id = 899
// module chunks = 3